<template>
    <draggable-accordion
        :unique_id="unique_id"
        :edit="data.edit"
    >
        <template #icon>
            <!-- Content block -->
            <svg v-if="data.type === 'content_block'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><polyline fill="none" points="14 2 14 8 20 8" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="16" x2="8" y1="13" y2="13"/><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" x1="16" x2="8" y1="17" y2="17"/><polyline fill="none" points="10 9 9 9 8 9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>
            <!-- Image -->
            <svg v-else-if="data.type === 'image'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M4.828 21l-.02.02-.021-.02H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H4.828zM20 15V5H4v14L14 9l6 6zm0 2.828l-6-6L6.828 19H20v-1.172zM8 11a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>
            <!-- Text -->
            <svg v-else-if="data.type === 'text'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M13 6v15h-2V6H5V4h14v2z"/></svg>
            <!-- CTA -->
            <svg v-else-if="data.type === 'cta'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM10.622 8.415l4.879 3.252a.4.4 0 0 1 0 .666l-4.88 3.252a.4.4 0 0 1-.621-.332V8.747a.4.4 0 0 1 .622-.332z"/></svg>
            <!-- FAQ -->
            <svg v-else-if="data.type === 'faq'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.501 3.501 0 1 1 13 13.355z"/></svg>
            <!-- Links -->
            <svg v-else-if="data.type === 'link'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.008 8.008 0 0 0 5.648 6.667zM10.03 13c.151 2.439.848 4.73 1.97 6.752A15.905 15.905 0 0 0 13.97 13h-3.94zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 19.938 13zM4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.008 8.008 0 0 0 4.062 11zm5.969 0h3.938A15.905 15.905 0 0 0 12 4.248 15.905 15.905 0 0 0 10.03 11zm4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.008 8.008 0 0 0-5.648-6.667z"/></svg>
            <!-- Earnings calculator -->
            <svg v-else-if="data.type === 'earnings_calculator'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-3.5-6H14a.5.5 0 1 0 0-1h-4a2.5 2.5 0 1 1 0-5h1V6h2v2h2.5v2H10a.5.5 0 1 0 0 1h4a2.5 2.5 0 1 1 0 5h-1v2h-2v-2H8.5v-2z"/></svg>
            <!-- How it works -->
            <svg v-else-if="data.type === 'how_it_works'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M8 4h13v2H8V4zM4.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 6.9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM8 11h13v2H8v-2zm0 7h13v2H8v-2z"/></svg>
            <!-- Embed code -->
            <svg v-else-if="data.type === 'embed'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M24 12l-5.657 5.657-1.414-1.414L21.172 12l-4.243-4.243 1.414-1.414L24 12zM2.828 12l4.243 4.243-1.414 1.414L0 12l5.657-5.657L7.07 7.757 2.828 12zm6.96 9.071l-1.94-.485L13.212 2.93l1.94.485L8.788 21.07z"/></svg>
            <!-- Custom block -->
            <svg v-else-if="data.type === 'custom_block'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M22 9.999V20a1 1 0 0 1-1 1h-8V9.999h9zm-11 0V21H3a1 1 0 0 1-1-1V9.999h9zM11 3v4.999H2V4a1 1 0 0 1 1-1h8zm10 0a1 1 0 0 1 1 1v3.999h-9V3h8z"/></svg>
            <!-- Divider -->
            <svg v-else-if="data.type === 'divider'" class="w-5 h-5 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-width="2" d="M4 12h16"/></svg>
            <!-- Available rewards -->
            <svg v-else-if="data.type === 'available_rewards'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M20 12a8 8 0 1 0-16 0v4.5a3.5 3.5 0 0 0 3.5 3.5H9a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H5.5A6.5 6.5 0 0 1 12 5.5a6.5 6.5 0 0 1 6.5 6.5H15a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1.5a3.5 3.5 0 0 0 3.5-3.5V12z"/></svg>
            <!-- Default fallback -->
            <svg v-else class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path d="M13 6v15h-2V6H5V4h14v2z"/></svg>
        </template>
        <template #title>{{ getResourceName(data.type) }}</template>
        <template #content>

            <div class="space-y-4" v-if="data.type !== 'divider' && data.type !== 'embed'">

                <div>
                    <div class="flex items-center justify-between mb-1.5">
                        <label class="text-sm">Thumbnail</label>
                        <div v-if="data.main_image?.url" class="flex items-center gap-3">
                            <div class="flex items-center">
                                <span class="text-xs text-gray-400 mr-1">Size:</span>
                                <select
                                    v-model="data.main_image_size"
                                    class="border-0 focus:ring-0 leading-4 text-xs text-gray-500 p-0 pr-6 bg-transparent cursor-pointer"
                                >
                                    <option value="small">Small</option>
                                    <option value="medium">Medium</option>
                                    <option value="large">Large</option>
                                    <option value="@2x">@2x</option>
                                </select>
                            </div>
                            <div class="flex items-center">
                                <span class="text-xs text-gray-400 mr-1">Position:</span>
                                <select
                                    v-model="data.main_image_position"
                                    class="border-0 focus:ring-0 leading-4 text-xs text-gray-500 p-0 pr-6 bg-transparent cursor-pointer"
                                >
                                    <option value="left">Left</option>
                                    <option value="top">Top</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <ResourceFileUpload
                        :unique_id="unique_id"
                        :data="data.main_image ?? {}"
                        accept="image/*"
                        title="Click to upload or drag & drop"
                        name="main_image"
                        size="dropzone"
                        @uploaded="uploadedMainImage"
                        @deleted="deletedMainImage"
                        no_src="/images/upload-image.png"
                    />
                </div>

                <div>
                    <div class="flex justify-between items-center mb-1.5">
                        <label class="block text-sm">Title</label>
                        <div class="inline-flex items-center gap-1">
                            <button
                                type="button"
                                class="p-1 rounded"
                                :class="[(!data.alignment || data.alignment === 'left') ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600']"
                                @click="data.alignment = 'left'"
                                title="Align left"
                            >
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h10M4 18h14"/></svg>
                            </button>
                            <button
                                type="button"
                                class="p-1 rounded"
                                :class="[data.alignment === 'center' ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600']"
                                @click="data.alignment = 'center'"
                                title="Align center"
                            >
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M7 12h10M5 18h14"/></svg>
                            </button>
                            <button
                                type="button"
                                class="p-1 rounded"
                                :class="[data.alignment === 'right' ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600']"
                                @click="data.alignment = 'right'"
                                title="Align right"
                            >
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M10 12h10M6 18h14"/></svg>
                            </button>
                        </div>
                    </div>
                    <text-field
                        type="text"
                        v-model="data.title"
                        placeholder="Enter a title or leave it empty"
                    />
                </div>

                <div>
                    <text-editor
                        :text="data.description"
                        @input="(newValue) => { data.description = newValue }"
                    />
                </div>

                <div class="" v-if="stringToComponent(data.type)">
                    <div class="border border-dashed rounded p-4 text-sm text-center mb-1.5"
                         v-if="!data?.contents?.length && showSubContentBlock(data.type)"
                    >
                        Click button below to start adding content or content blocks.
                    </div>
                    <component
                        :is="stringToComponent(data.type)"
                        :data="data"
                        :unique_id="data.unique_id"
                    />
                </div>
            </div>

            <div v-else>
                <component
                    :is="stringToComponent(data.type)"
                    :data="data"
                    :unique_id="data.unique_id"
                />
            </div>

        </template>
    </draggable-accordion>
</template>

<script setup>
import {getResourceName} from '../helpers';
import Text from './Text.vue';
import Link from './Link.vue';
import Faq from './Faq.vue';
import CTA from './CTA.vue';
import AvailableRewards from './AvailableRewards.vue';
import ContentBlock from './ContentBlock.vue';
import Image from './Image.vue';
import EarningsCalculator from './EarningsCalculator.vue';
import Divider from './Divider.vue';
import HowItWorks from './HowItWorks.vue';
import Embed from './Embed.vue';
import CustomBlock from './CustomBlock.vue';
import ResourceFileUpload from "./ResourceFileUpload.vue";
import TextField from "../../../../elements/forms/TextField";

const props = defineProps({
    data: Object,
    unique_id: String,
});

// Initialize main_image, main_image_size, and main_image_position defaults
props.data.main_image = props.data?.main_image ?? {};
if (!props.data.main_image_size) {
    // Migrate old retina resize setting to new size option
    if (props.data.main_image_retina_resize) {
        props.data.main_image_size = '@2x';
    } else {
        props.data.main_image_size = 'medium';
    }
}
if (!props.data.main_image_position) {
    props.data.main_image_position = 'left';
}

const uploadedMainImage = (data) => {
    props.data.main_image = data;
};

const deletedMainImage = (data) => {
    props.data.main_image = data;
};

/**
 * Sole purpose of this function is to load component in <component :is="">
 * To give component a local name string you need 'components' option
 * This will serve as workaround for <script setup>
 * @link https://github.com/vuejs/rfcs/discussions/273
 *
 * @param  {string} type
 * @return {Object}
 */
const stringToComponent = (type) => {
    switch (type) {
        case 'text':
            return Text;
        case 'link':
            return Link;
        case 'faq':
            return Faq;
        case 'cta':
            return CTA;
        case 'content_block':
            return ContentBlock;
        case 'image':
            return Image;
        case 'available_rewards':
            return AvailableRewards;
        case 'earnings_calculator':
            return EarningsCalculator;
        case 'how_it_works':
            return HowItWorks;
        case 'divider':
            return Divider;
        case 'embed':
            return Embed;
        case 'custom_block':
            return CustomBlock;
    }
}

const showSubContentBlock = (type) => {
    return type !== 'available_rewards' && type !== 'earnings_calculator' && type !== 'divider' && type !== 'embed' && type !== 'custom_block';
}

</script>
